module.exports = "<div class=\"rm-statement-box criteria-grey-box\">{{ statement }}</div>";